import { jsx as _jsx } from "react/jsx-runtime";
import MediaAttachment from '../MediaAttachments/MediaAttachment';
export const LabResultsAttachments = ({ message, consultation, onAttachmentClick, containerClass, }) => {
    return (_jsx("div", Object.assign({ className: containerClass }, { children: message.attachments
            .filter((el) => el.type === 'lab_results')
            .map((attachment) => {
            return (_jsx(MediaAttachment, { consultation: consultation, attachment: attachment, containerClass: containerClass, onAttachmentClick: onAttachmentClick }, attachment.id));
        }) })));
};
